export const theme = {
  color: {
    primary: "#283380",
    secondary: "#6C9FD5",
    gray: "#6C757D",
    blue: "#007BFF",
    red: "#DC3545",
    green: "#26B99A",
    blueBlack: "#4B5F71",
    skyBlue: "#0DBBEF",
    orange: "#FFA500",
    pdf: "#FF4B4B",
    mp3: "#6C9FD5",
  },
  hoverColor: {
    primary: "#181e4b",
    secondary: "#6C9FD5",
    gray: "#5D6771",
    blue: "#0170E7",
    red: "#CE2B3B",
    green: "#169F85",
    blueBlack: "#364B5F",
    skyBlue: "#0ca8d8",
    orange: "#F4A500",
    pdf: "#c43939",
    mp3: "#5e89b8",
  },
  fontSize: {
    ssm: "0.75rem",
    sm: "0.875rem",
    md: "1rem",
    lg: "1.25rem",
    xl: "1.5rem",
    xxl: "1.75rem",
    xxxl: "2rem",
  },
}